// extracted by mini-css-extract-plugin
module.exports = {"download-bar":"download-bar___1YG04","close":"close___1WRGr","logo":"logo___3jp2k","cont":"cont___359SV","tit":"tit___ZSLB_","desc":"desc___18LK2","down":"down___1XvmB"};